module.exports = __webpack_public_path__ + "img/approved.e11768b5.svg";